export const CLEAR_TEAMS = 'CLEAR_TEAMS'
export const CLEAR_ORG_USERS = 'CLEAR_ORG_USERS'
export const SET_TEAM_LIST = 'SET_TEAM_LIST'
export const SET_PODCAST_BULK_INVITES = 'SET_PODCAST_BULK_INVITES'
export const SET_CAN_CREATE_TEAM = 'SET_CAN_CREATE_TEAM'
export const SET_NETWORK_CREATE = 'SET_NETWORK_CREATE'
export const SET_NETWORK = 'SET_NETWORK'
export const SET_EDIT_ORG_USER = 'SET_EDIT_ORG_USER'
export const SET_EDIT_ORG_USER_NETWORKS = 'SET_EDIT_ORG_USER_NETWORKS'
export const SET_EDIT_ORG_USER_NETWORKS_COUNT = 'SET_EDIT_ORG_USER_NETWORKS_COUNT'
export const SET_EDIT_ORG_USER_SHOWS = 'SET_EDIT_ORG_USER_SHOWS'
export const SET_EDIT_ORG_USER_SHOWS_COUNT = 'SET_EDIT_ORG_USER_SHOWS_COUNT'
export const SET_ORG_INVITES = 'SET_ORG_INVITES'
export const SET_ORG_INVITES_COUNT = 'SET_ORG_INVITES_COUNT'
export const SET_ORG_INVITES_ROLE_OPTIONS = 'SET_ORG_INVITES_ROLE_OPTIONS'
export const SET_ORG_NETWORKS = 'SET_ORG_NETWORKS'
export const SET_ORG_NETWORKS_COUNT = 'SET_ORG_NETWORKS_COUNT'
export const SET_ORG_USER_ROLES = 'SET_ORG_USER_ROLES'
export const SET_ORG_USERS = 'SET_ORG_USERS'
export const SET_ORG_USERS_COUNT = 'SET_ORG_USERS_COUNT'
export const SET_ORG_USERS_ROLE_OPTIONS = 'SET_ORG_USERS_ROLE_OPTIONS'
